<template>
  <q-page padding>
    <template v-if="audit.id">
      <div class="row justify-center">
        <div class="col-12 q-py-none q-px-lg row items-center">
          <div class="q-mr-md" v-if="checkpointCategory">
            <q-avatar size="20px" color="primary">
              <img class="q-pa-xs" :src="checkpointCategory.img" />
            </q-avatar>
          </div>
          <div class="text-subtitle1">
            {{ checkpoint?.question }}
          </div>
        </div>
      </div>
      <new-issue
        @goNext="goBack"
        :audit="audit"
        :category="category"
      ></new-issue>
    </template>
  </q-page>
</template>

<script>
import NewIssue from 'src/components/issues/New'
import { mapGetters } from 'vuex'
import { getCheckpointCategoryId } from 'src/utils/checkpoints'
import { findCategoryById } from 'src/utils/categories'

export default {
  components: {
    NewIssue
  },
  data() {
    return {
      audit: {}
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    async loadAudit() {
      const auditId = Number(this.$route.params.auditId)
      if (this.$route.query.tab === 'myScope') {
        const storedAudit = await this.$patrimoine
          .auditsCollection()
          .get(`${auditId}`)
        if (!storedAudit) {
          throw 'Audit not found in PouchDB'
        }
        this.audit = storedAudit
      } else {
        this.audit = this.auditsInOtherScopes.find(
          (audit) => audit.id === Number(this.$route.params.auditId)
        )
      }
    }
  },
  computed: {
    ...mapGetters({
      audits: 'audits/all',
      categories: 'company/categories',
      auditsInOtherScopes: 'audits/auditsInOtherScopes'
    }),
    checkpoint() {
      if (!this.audit.id) return undefined
      return (this.audit.checkpoints || []).find(
        (checkpoint) =>
          Number(checkpoint.id) === Number(this.$route.query.checkpoint)
      )
    },
    category() {
      if (!this.audit.id) return undefined
      const categoryId = this.audit.checklist?.category?.id
      let cat = this.categories.find((category) => category.id === categoryId)
      if (cat === undefined) {
        this.categories.every((category) => {
          cat = category.childs.find((child) => child.id === categoryId)
          return cat === undefined
        })
      }
      return cat
    },
    checkpointCategory() {
      if (!this.checkpoint) return undefined
      // NOTE: RUN-2927 — fallback sur la catégorie du checklist quand le
      // checkpoint n'a pas (encore) la sienne en base locale
      return (
        findCategoryById(
          this.categories,
          getCheckpointCategoryId(this.checkpoint)
        ) || this.category
      )
    }
  },
  watch: {
    audits: () => {
      this.loadAudit()
    }
  },
  mounted() {
    this.$q.loading.hide()
    this.loadAudit()
  }
}
</script>
